"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkelloLicenseModel = void 0;
const permissions_json_1 = __importDefault(require("../constants/permissions.json"));
class SkelloLicenseModel {
    constructor(props) {
        this.canCreateAmendment = false;
        this.canCreateClusterNode = false;
        this.canCreateEmployee = false;
        this.canCreateOrganisation = false;
        this.canCreatePosteAndTeam = false;
        this.canCreateSelfAvailabilities = false;
        this.canCreateSelfLeaveRequests = false;
        this.canCreateShiftSwap = false;
        this.canCreateShifts = false;
        this.canCreateShop = false;
        this.canEditActivityReport = false;
        this.canEditBonus = false;
        this.canEditEmployeeInfo = false;
        this.canEditEmployeePersonalInfosAndBankData = false;
        this.canEditLegalAlertsConfig = false;
        this.canEditManagementIndicators = false;
        this.canEditPunchClockData = false;
        this.canEditPunchClockSettings = false;
        this.canEditReportColumns = false;
        this.canEditReportComment = false;
        this.canEditSelfHr = false;
        this.canEditShifts = false;
        this.canEditShopBillingData = false;
        this.canEditShopPermissions = false;
        this.canEditShopRulesAndAbsences = false;
        this.canEditWageAndTime = false;
        this.canLockPlanning = false;
        this.canManageEmployeeDocuments = false;
        this.canManageEmployeeRequests = false;
        this.canPublishPlanning = false;
        this.canReadAllEmployees = false;
        this.canReadEmployeeInfo = false;
        this.canReadEmployeePersonalInfosAndBankData = false;
        this.canReadEmployeesOnSvcEmployees = false;
        this.canUploadSelfDocuments = false;
        this.canReadHoursCounterAndTotal = false;
        this.canReadPaidVacationCounter = false;
        this.canReadPunchClockData = false;
        this.canReadReport = false;
        this.canReadSelfOnly = false;
        this.canReadShopRulesAndAbsences = false;
        this.canReadTeammates = false;
        this.canArchiveAndRestoreUsers = false;
        this.canTmplockPlanning = false;
        this.canWriteLastTabletSync = false;
        this.canReadTimeClockSettings = false;
        this.canWriteClockInOuts = false;
        this.canWriteTimeClockPin = false;
        this.canReadClockInOuts = false;
        this.canReadTimeClockUsers = false;
        this.canManageOwnTimeClockData = false;
        this.canManageDocumentTemplates = false;
        this.canManageMissions = false;
        this.canEditMissions = false;
        this.canReadMissions = false;
        Object.assign(this, props);
    }
    static fromJSON(props) {
        return new SkelloLicenseModel(props);
    }
    static fromBin(bin) {
        const skelloLicense = new SkelloLicenseModel();
        const binToPermissionsMapping = {};
        Object.keys(permissions_json_1.default).forEach((permission) => (binToPermissionsMapping[permissions_json_1.default[permission]] = permission));
        bin.split('').forEach((char) => (skelloLicense[binToPermissionsMapping[char]] = true));
        return skelloLicense;
    }
    static getPermissionsToBinMapping() {
        return permissions_json_1.default;
    }
    static getPermissionsToBin(license) {
        return Object.keys(permissions_json_1.default)
            .filter((key) => license[key])
            .map((key) => permissions_json_1.default[key])
            .join('');
    }
    toJSON() {
        const result = {
            canArchiveAndRestoreUsers: this.canArchiveAndRestoreUsers,
            canCreateAmendment: this.canCreateAmendment,
            canCreateClusterNode: this.canCreateClusterNode,
            canCreateEmployee: this.canCreateEmployee,
            canCreateOrganisation: this.canCreateOrganisation,
            canCreatePosteAndTeam: this.canCreatePosteAndTeam,
            canCreateSelfAvailabilities: this.canCreateSelfAvailabilities,
            canCreateSelfLeaveRequests: this.canCreateSelfLeaveRequests,
            canCreateShiftSwap: this.canCreateShiftSwap,
            canCreateShifts: this.canCreateShifts,
            canCreateShop: this.canCreateShop,
            canEditActivityReport: this.canEditActivityReport,
            canEditBonus: this.canEditBonus,
            canEditEmployeeInfo: this.canEditEmployeeInfo,
            canEditEmployeePersonalInfosAndBankData: this.canEditEmployeePersonalInfosAndBankData,
            canEditLegalAlertsConfig: this.canEditLegalAlertsConfig,
            canEditManagementIndicators: this.canEditManagementIndicators,
            canEditMissions: this.canEditMissions,
            canEditPunchClockData: this.canEditPunchClockData,
            canEditPunchClockSettings: this.canEditPunchClockSettings,
            canEditReportColumns: this.canEditReportColumns,
            canEditReportComment: this.canEditReportComment,
            canEditSelfHr: this.canEditSelfHr,
            canEditShifts: this.canEditShifts,
            canEditShopBillingData: this.canEditShopBillingData,
            canEditShopPermissions: this.canEditShopPermissions,
            canEditShopRulesAndAbsences: this.canEditShopRulesAndAbsences,
            canEditWageAndTime: this.canEditWageAndTime,
            canLockPlanning: this.canLockPlanning,
            canManageDocumentTemplates: this.canManageDocumentTemplates,
            canManageEmployeeDocuments: this.canManageEmployeeDocuments,
            canManageEmployeeRequests: this.canManageEmployeeRequests,
            canManageMissions: this.canManageMissions,
            canManageOwnTimeClockData: this.canManageOwnTimeClockData,
            canPublishPlanning: this.canPublishPlanning,
            canReadAllEmployees: this.canReadAllEmployees,
            canReadClockInOuts: this.canReadClockInOuts,
            canReadEmployeeInfo: this.canReadEmployeeInfo,
            canReadEmployeePersonalInfosAndBankData: this.canReadEmployeePersonalInfosAndBankData,
            canReadEmployeesOnSvcEmployees: this.canReadEmployeesOnSvcEmployees,
            canReadHoursCounterAndTotal: this.canReadHoursCounterAndTotal,
            canReadMissions: this.canReadMissions,
            canReadPaidVacationCounter: this.canReadPaidVacationCounter,
            canReadPunchClockData: this.canReadPunchClockData,
            canReadReport: this.canReadReport,
            canReadSelfOnly: this.canReadSelfOnly,
            canReadShopRulesAndAbsences: this.canReadShopRulesAndAbsences,
            canReadTeammates: this.canReadTeammates,
            canReadTimeClockUsers: this.canReadTimeClockUsers,
            canTmplockPlanning: this.canTmplockPlanning,
            canUploadSelfDocuments: this.canUploadSelfDocuments,
            canWriteClockInOuts: this.canWriteClockInOuts,
            canWriteLastTabletSync: this.canWriteLastTabletSync,
            canWriteTimeClockPin: this.canWriteTimeClockPin,
        };
        return Object.fromEntries(Object.entries(result).filter(([, v]) => v));
    }
}
exports.SkelloLicenseModel = SkelloLicenseModel;
//# sourceMappingURL=SkelloLicenseModel.js.map